// @ts-nocheck
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { flow, Instance, types } from 'mobx-state-tree';
import { DutyExchangeItem } from './models/DutyExchangeItem';

export const DutyExchangeItemSearchCriteria = types.model({
  pharmacyId: types.maybeNull(types.number),
  onlyFutureDutyExchange: types.maybeNull(types.boolean),
});

export const DutyExchangeItemStore = types
  .compose(
    getBaseStore<Instance<typeof DutyExchangeItem>, Instance<typeof DutyExchangeItem>>(
      DutyExchangeItem,
      'dutyExchangeItemId',
      'dutyExchangeItem',
    ),
    types.model('DutyExchangeItemStore', {}),
  )
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const updateDutyExchangeItemInStore = (dutyExchangeItem: Instance<typeof DutyExchangeItem>) => {
      const dutyExchangeItemModel = DutyExchangeItem.create(dutyExchangeItem);
      self.datas.put(dutyExchangeItemModel);
      return dutyExchangeItemModel;
    };

    const search = flow(function*(criteria: Instance<typeof DutyExchangeItemSearchCriteria>) {
      const result = yield apiFetcher.get('dutyExchangeItem', {
        params: criteria,
      });
      const resultDutyExchangeItem: Array<Instance<typeof DutyExchangeItem>> = [];
      // @ts-ignore
      result.forEach((node) => {
        const createdDutyExchangeItem = updateDutyExchangeItemInStore(node);
        resultDutyExchangeItem.push(createdDutyExchangeItem);
      });
      return resultDutyExchangeItem;
    });

    return {
      search,
    };
  });
